import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      <Navbar />

      {/* Hero Section */}
      <section className="py-20 px-6">
        <div className="container mx-auto text-center max-w-4xl">
          <h1 className="text-5xl font-bold text-gray-800 mb-6">
            Welcome to Baainearme (BNM)
          </h1>
          <p className="text-xl text-gray-600 mb-12">
            Your trusted platform for on-demand home services
          </p>

          <div className="text-lg text-gray-700 mb-16">
            Choose your path:
          </div>

          {/* Dual Entry Cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Customer Card */}
            <Link to="/customer" className="group cursor-pointer">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-2 border-transparent hover:border-purple-200">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-200 transition-colors">
                  <i className="ri-user-line text-2xl text-purple-600"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">I'm a Customer</h2>
                <p className="text-gray-600 mb-6">
                  Book verified services at your doorstep
                </p>
                <div className="bg-purple-600 text-white px-8 py-3 rounded-full font-semibold group-hover:bg-purple-700 transition-colors whitespace-nowrap">
                  Get Started
                </div>
              </div>
            </Link>

            {/* Partner Card */}
            <Link to="/partner" className="group cursor-pointer">
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border-2 border-transparent hover:border-purple-200">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-200 transition-colors">
                  <i className="ri-tools-line text-2xl text-purple-600"></i>
                </div>
                <h2 className="text-2xl font-bold text-gray-800 mb-4">I'm a Service Partner</h2>
                <p className="text-gray-600 mb-6">
                  Join BNM and start earning steady income
                </p>
                <div className="bg-purple-600 text-white px-8 py-3 rounded-full font-semibold group-hover:bg-purple-700 transition-colors whitespace-nowrap">
                  Join Now
                </div>
              </div>
            </Link>
          </div>

          <p className="text-lg text-gray-600 mt-16">
            Simple, secure, and designed to connect households with skilled professionals
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Why Choose BNM?</h2>
            <p className="text-xl text-gray-600">Trusted by thousands across India</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Verified Partners</h3>
              <p className="text-gray-600">All service providers are thoroughly vetted and verified</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Quick Booking</h3>
              <p className="text-gray-600">Book services in under 2 minutes with just a few taps</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-rupee-circle-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Transparent Pricing</h3>
              <p className="text-gray-600">Cashless payments with clear, upfront pricing</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="py-16 bg-purple-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Popular Services</h2>
            <p className="text-xl text-gray-600">Everything you need for your home</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4  gap-6 max-w-6xl mx-auto">
            {[
              { icon: 'ri-drop-line', name: 'Bathroom Cleaning Basic' },
              { icon: 'ri-shining-line', name: 'Bathroom Cleaning Intense' },
              { icon: 'ri-brush-2-line', name: 'Dusting' },
              { icon: 'ri-home-heart-line', name: 'Sofa Cleaning' },
              { icon: 'ri-eraser-line', name: 'Carpet Cleaning' },
              { icon: 'ri-knife-line', name: 'Kitchen Utensil Cleaning' },
              { icon: 'ri-windy-line', name: 'Fan Cleaning' },
              { icon: 'ri-window-line', name: 'Window Cleaning' },
              { icon: 'ri-restaurant-line', name: 'Cooking' },
              { icon: 'ri-filter-3-line', name: 'Water Filter' },
            ].map((service, index) => (
              <div key={index} className="bg-white rounded-xl p-6 text-center shadow-sm hover:shadow-md transition-shadow cursor-pointer">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className={`${service.icon} text-xl text-purple-600`}></i>
                </div>
                <p className="text-sm font-medium text-gray-700">{service.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-purple-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="text-xl mb-12 max-w-2xl mx-auto">
            Join thousands of satisfied customers and partners who trust BNM for their home service needs
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/customer" className="bg-white text-purple-600 px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              Book a Service
            </Link>
            <Link to="/partner" className="bg-purple-700 text-white px-8 py-4 rounded-full font-semibold hover:bg-purple-800 transition-colors cursor-pointer whitespace-nowrap border-2 border-purple-700">
              Become a Partner
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              {/* BNM logo (SVG) — scalable, color via currentColor */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 420 160"
                className="h-10 text-white"   // change to text-purple-600 etc.
                role="img"
                aria-label="BNM · Baainearme"
              >
                <g fill="none" stroke="currentColor" strokeWidth="12" strokeLinecap="round">
                  {/* Left ring */}
                  <circle cx="50" cy="60" r="40" />
                  {/* Vertical divider */}
                  <line x1="110" y1="20" x2="110" y2="120" />
                </g>

                {/* Text block */}
                <g fill="currentColor">
                  {/* BNM */}
                  <text
                    x="140"
                    y="72"
                    fontFamily="Poppins, Inter, Arial, sans-serif"
                    fontWeight="800"
                    fontSize="56"
                  >
                    BNM
                  </text>

                  {/* Baainearme */}
                  <text
                    x="140"
                    y="120"
                    fontFamily="Poppins, Inter, Arial, sans-serif"
                    fontWeight="700"
                    fontSize="32"
                  >
                    Baainearme
                  </text>
                </g>
              </svg>

              <p className="text-gray-400">
                Simplifying everyday life by connecting customers with trusted service providers
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer" className="hover:text-white cursor-pointer">For Customers</Link></li>
                <li><Link to="/partner" className="hover:text-white cursor-pointer">For Partners</Link></li>
                <li><Link to="/about" className="hover:text-white cursor-pointer">About Us</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Press</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/press" className="hover:text-white cursor-pointer">Press Releases</Link></li>
                <li><Link to="/ads" className="hover:text-white cursor-pointer">Ads and Marketing</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Legal</h3>
              <ul className="space-y-2 text-gray-400">
                <li><Link to="/customer-terms" className="hover:text-white cursor-pointer">Terms & Conditions</Link></li>
                <li><Link to="/customer-privacy" className="hover:text-white cursor-pointer">Privacy Policy</Link></li>
                <li><Link to="/refund-policy" className="hover:text-white cursor-pointer">Refund Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Baainearme. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
